"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "padru": {
    "1646fb59": [{
      "hkey": "b2fd3b70",
      "slug": "padru",
      "name": "Padru",
      "primary": true,
      "skipSearch": false
    }],
    "budo": [{
      "hkey": "b2fd3b70",
      "slug": "padru",
      "name": "Padru",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "53d78b75": [{
      "hkey": "b2fd3b70",
      "slug": "padru",
      "name": "Padru",
      "primary": true,
      "skipSearch": false
    }],
    "graniadolzu": [{
      "hkey": "b2fd3b70",
      "slug": "padru",
      "name": "Padru",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "20bb6e49": [{
      "hkey": "b2fd3b70",
      "slug": "padru",
      "name": "Padru",
      "primary": true,
      "skipSearch": false
    }],
    "nodalvu": [{
      "hkey": "b2fd3b70",
      "slug": "padru",
      "name": "Padru",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "01adc3e0": [{
      "hkey": "5434df3f",
      "slug": "pedra-bianca",
      "name": "Pedra Bianca",
      "primary": true,
      "skipSearch": false
    }],
    "pedrabianca": [{
      "hkey": "5434df3f",
      "slug": "pedra-bianca",
      "name": "Pedra Bianca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "72d6e5fb": [{
      "hkey": "b2fd3b70",
      "slug": "padru",
      "name": "Padru",
      "primary": true,
      "skipSearch": false
    }],
    "sas-enas": [{
      "hkey": "b2fd3b70",
      "slug": "padru",
      "name": "Padru",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;